import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useI18N } from "@sundae/react-hooks";
import { Badge, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, ReactNode, memo } from "react";

import { TPool } from "../../types/Pool.types";
import PoolComponent from "../PoolComponent";

export interface IPoolSelectItemProps {
  balance: ReactNode;
  balanceLabel: ReactNode;
  className?: string;
  isSelected?: boolean;
  onClick: () => void;
  pool: TPool;
}

const PoolSelectItem: FC<IPoolSelectItemProps> = ({
  balance,
  balanceLabel,
  className,
  isSelected,
  onClick,
  pool,
}) => {
  const { t } = useI18N();
  return (
    <button
      className={cx(
        "h-fit w-full cursor-pointer select-none p-4",
        "flex items-center justify-between gap-2 md:gap-4",
        "rounded-lg",
        toolkitCx.layout.border.weight.default,
        toolkitCx.layout.background.hoverable,
        toolkitCx.layout.transition.default,
        {
          [`cursor-pointer ${toolkitCx.layout.background.card} ${toolkitCx.layout.border.default} ${toolkitCx.recipes.scaleWhenActive}`]:
            !isSelected,
          [`cursor-not-allowed ${toolkitCx.recipes.blurryCorner.success} ${toolkitCx.layout.border.success}`]:
            isSelected,
        },
        className
      )}
      onClick={onClick}
    >
      <div className="flex gap-2">
        <PoolComponent pool={pool} />
        {isSelected && (
          <Badge className="h-fit" size="2xs" variant="success">
            <CheckCircleIcon className={cx("mr-1 h-3 w-3", toolkitCx.layout.text.success)} />
            {t("selected")}
          </Badge>
        )}
      </div>

      <div className="grid gap-1 text-right">
        {typeof balanceLabel === "string" ? (
          <Text tag="span" size="2xs" variant="muted">
            {balanceLabel}
          </Text>
        ) : (
          balanceLabel
        )}

        {balance}
      </div>
    </button>
  );
};

export default memo(PoolSelectItem);
